import { notifications } from '@mantine/notifications';
import type { ToastProps } from './toast.model';

const defaultValues = {
  title: 'Info',
  message: 'Message',
};

export const info = (props?: ToastProps) => {
  const { id, cb, ...others } = props ?? {};
  notifications.show({
    ...defaultValues,
    ...others,
    color: 'primary',
    id,
  });
  if (id) {
    notifications?.update({ ...defaultValues, ...others, id });
  }
  cb?.();
};
